<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Közösségi szolgálat</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card>
    <ion-card-header>
      <ion-card-title>Közösségi szolgálat</ion-card-title>
      <ion-card-subtitle>
        Az érettségi bizonyítvány kiadásához <b>{{ cel }} óra</b> közösségi szolgálat kell. A tételek a
        KRÉTÁ-ból jönnek, és itt is rögzíthetők.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <div class="ik-fejlec">
        <ion-select label="Osztály" label-placement="stacked" interface="popover" fill="outline"
                    [(ngModel)]="osztaly" [disabled]="osztalyok.length < 2">
          <ion-select-option value="">Minden osztály</ion-select-option>
          <ion-select-option *ngFor="let o of osztalyok" [value]="o">{{ o }}</ion-select-option>
        </ion-select>
        <ion-select label="Állapot" label-placement="stacked" interface="popover" fill="outline" [(ngModel)]="allapot">
          <ion-select-option value="mind">Mind</ion-select-option>
          <ion-select-option value="hianyzik">Még nincs meg az {{ cel }} óra</ion-select-option>
          <ion-select-option value="teljesitve">Teljesítette</ion-select-option>
          <ion-select-option value="visszairas">KRÉTÁ-ba visszaírandó tétele van</ion-select-option>
        </ion-select>
        <ion-input label="Keresés" label-placement="stacked" fill="outline" placeholder="tanuló neve"
                   [(ngModel)]="szuro"></ion-input>
        <ion-button fill="clear" size="small" (click)="betolt()" [disabled]="toltodik">
          <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
        </ion-button>
      </div>

      <div class="ik-forras">
        <span *ngIf="utolsoSzinkron">
          Utolsó KRÉTA-szinkron: <b>{{ utolsoSzinkron.indult }}</b>
        </span>
        <span *ngIf="!utolsoSzinkron">Még nem volt KRÉTA-szinkron – csak az itt rögzített tételek látszanak.</span>
        <a *ngIf="admin" routerLink="/admin/iksz-szinkron">KRÉTA-szinkron beállítása</a>
      </div>

      <div class="ik-allapot" *ngIf="toltodik">
        <ion-spinner name="dots"></ion-spinner><span>Betöltés…</span>
      </div>
      <div class="ik-allapot hiba" *ngIf="!toltodik && hiba">
        <ion-icon name="alert-circle-outline"></ion-icon><span>{{ hiba }}</span>
      </div>

      <ng-container *ngIf="!toltodik && !hiba">
        <div class="ik-ures" *ngIf="!tanulok.length">
          Nincs megjeleníthető tanuló. Az osztályfőnök a saját (9. évfolyamos vagy felsőbb) osztályait
          látja itt.
        </div>

        <ng-container *ngIf="tanulok.length">
          <div class="ik-osszesito">
            <div><span class="szam">{{ osszesito.tanulo }}</span><span>tanuló</span></div>
            <div class="jo"><span class="szam">{{ osszesito.teljesitve }}</span><span>teljesítette</span></div>
            <div class="baj"><span class="szam">{{ osszesito.hianyzik }}</span><span>még hiányzik</span></div>
            <div><span class="szam">{{ ora(osszesito.hianyzoOra) }}</span><span>óra hiányzik összesen</span></div>
            <div *ngIf="osszesito.visszairas" class="var">
              <span class="szam">{{ osszesito.visszairas }}</span><span>KRÉTÁ-ba visszaírandó</span>
            </div>
          </div>

          <div class="ik-ures" *ngIf="!szurt.length">Erre a szűrésre nincs tanuló.</div>

          <div class="ik-tabla-burok" *ngIf="szurt.length">
            <table class="ik-tabla">
              <thead>
                <tr>
                  <th></th><th>Tanuló</th><th>Osztály</th><th class="haladas-fej">Órák</th>
                  <th class="szam">Hiányzik</th><th class="szam">Tétel</th><th></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let t of szurt; trackBy: trackTanulo">
                  <tr class="tanulo" [class.nyitva]="nyitott.has(t.oktazon)" (click)="valt(t.oktazon)">
                    <td class="nyil">
                      <ion-icon [name]="nyitott.has(t.oktazon) ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
                    </td>
                    <td>
                      {{ t.nev }}
                      <span class="jel var" *ngIf="t.visszairasra_var" title="Itt rögzített vagy módosított tétel, a KRÉTÁ-ban még nem szerepel így">
                        {{ t.visszairasra_var }} visszaírandó
                      </span>
                    </td>
                    <td>{{ t.osztaly_nev }}</td>
                    <td class="haladas">
                      <div class="sav" [attr.aria-label]="ora(t.ora) + ' óra a ' + cel + '-ből'">
                        <div class="kitoltes" [class.kesz]="t.teljesitve" [style.width.%]="szazalek(t)"></div>
                      </div>
                      <span class="ertek"><b>{{ ora(t.ora) }}</b> / {{ cel }}</span>
                    </td>
                    <td class="szam">
                      <span class="jel ok" *ngIf="t.teljesitve">megvan</span>
                      <span *ngIf="!t.teljesitve">{{ ora(hianyzoOra(t)) }} óra</span>
                    </td>
                    <td class="szam">{{ t.tetelek.length }}</td>
                    <td class="muvelet">
                      <ion-button size="small" fill="clear" (click)="$event.stopPropagation(); ujTetel(t)">
                        <ion-icon slot="start" name="add-outline"></ion-icon>Új tétel
                      </ion-button>
                    </td>
                  </tr>

                  <tr *ngIf="nyitott.has(t.oktazon)" class="reszlet">
                    <td colspan="7">
                      <div class="ik-ures kicsi" *ngIf="!t.tetelek.length && urlap?.oktazon !== t.oktazon">
                        Még nincs rögzített közösségi szolgálat.
                      </div>

                      <table class="ik-tetelek" *ngIf="t.tetelek.length">
                        <thead>
                          <tr><th>Időszak</th><th class="szam">Óra</th><th>Tevékenység</th><th>Teljesítés helye</th><th>Megjegyzés</th><th>Forrás</th><th></th></tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let x of t.tetelek; trackBy: trackTetel" [class.szerkesztve]="urlap?.id === x.id">
                            <td class="datum">{{ idoszak(x) }}</td>
                            <td class="szam">{{ ora(x.oraszam) }}</td>
                            <td class="tipus" [title]="x.tipus">{{ x.tipus }}</td>
                            <td>{{ x.teljesitesi_hely || '—' }}</td>
                            <td class="megj" [title]="x.megjegyzes || ''">{{ x.megjegyzes || '—' }}</td>
                            <td>
                              <span class="jel" *ngIf="x.forras === 'kreta'">KRÉTA</span>
                              <span class="jel sajat" *ngIf="x.forras === 'sulinform'" [title]="x.rogzitette ? 'Rögzítette: ' + x.rogzitette : ''">itt rögzítve</span>
                              <span class="jel var" *ngIf="x.kreta_allapot === 'visszairasra_var'">visszaírandó</span>
                            </td>
                            <td class="muvelet">
                              <ion-button size="small" fill="clear" (click)="szerkeszt(t, x)">Módosítás</ion-button>
                              <ion-button size="small" fill="clear" color="danger" (click)="torol(x)">Törlés</ion-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <form class="ik-urlap" *ngIf="urlap?.oktazon === t.oktazon && urlap as u" (ngSubmit)="mentes()">
                        <div class="ik-urlap-cim">{{ u.id ? 'Tétel módosítása' : 'Új tétel' }} – {{ t.nev }}</div>
                        <div class="ik-racs">
                          <ion-input label="Kezdete" label-placement="stacked" fill="outline" type="date"
                                     name="kezdete" [(ngModel)]="u.kezdete" required></ion-input>
                          <ion-input label="Vége" label-placement="stacked" fill="outline" type="date"
                                     name="vege" [(ngModel)]="u.vege" [min]="u.kezdete"></ion-input>
                          <ion-input label="Óraszám" label-placement="stacked" fill="outline" type="number"
                                     inputmode="decimal" step="0.5" min="0.5" [max]="cel"
                                     name="oraszam" [(ngModel)]="u.oraszam" required></ion-input>
                          <ion-select class="szeles" label="Tevékenység típusa" label-placement="stacked" fill="outline"
                                      interface="popover" name="tipus" [(ngModel)]="u.tipus">
                            <ion-select-option *ngFor="let n of tipusValasztek()" [value]="n">{{ n }}</ion-select-option>
                          </ion-select>
                          <ion-input class="szeles" label="Teljesítés helye" label-placement="stacked" fill="outline"
                                     name="hely" [(ngModel)]="u.teljesitesi_hely" maxlength="255"></ion-input>
                          <ion-textarea class="teljes" label="Megjegyzés" label-placement="stacked" fill="outline"
                                        [autoGrow]="true" name="megjegyzes" [(ngModel)]="u.megjegyzes" maxlength="2000"></ion-textarea>
                        </div>
                        <ion-note color="medium" class="ik-sugo" *ngIf="u.kreta">
                          Ez a tétel a KRÉTÁ-ból jött. A módosítás itt azonnal érvényes, a KRÉTÁ-ba
                          visszaírandóként jelöljük, és a következő szinkron nem írja felül.
                        </ion-note>
                        <ion-note color="medium" class="ik-sugo" *ngIf="!u.kreta">
                          Az itt rögzített tétel a KRÉTÁ-ban még nem jelenik meg: visszaírandóként jelöljük.
                        </ion-note>
                        <div class="ik-gombok">
                          <ion-button type="submit" size="small" [disabled]="mentesFut">
                            <ion-spinner *ngIf="mentesFut" name="dots" slot="start"></ion-spinner>
                            Mentés
                          </ion-button>
                          <ion-button size="small" fill="outline" color="medium" (click)="urlap = null">Mégse</ion-button>
                        </div>
                      </form>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </ng-container>
      </ng-container>
    </ion-card-content>
  </ion-card>
</ion-content>
